<template>
  <div v-if="isLoggedIn">
    <div class="row">
      <div class="col"></div>
      <q-toggle dense flat v-model="showAllColours" left-label
                :label="showAllColours ? 'Showing All Colours' : 'Showing Available Colours Only'"
                class="q-mt-sm">
        <q-tooltip v-if="!showAllColours">Always check the colour popup when this is off</q-tooltip>
      </q-toggle>
    </div>
    <q-table
      class="q-my-lg"
      :data="displayedProducts"
      :columns="columns"
      dense
      :loading="$apollo.queries.displayedProducts.loading"
      :pagination.sync="pagination"
      @request="onRequest"
      :visible-columns="visibleColumns"
      :rows-per-page-options="[20, 50, 100, 150, 200]"
      binary-state-sort
      row-key="id">

      <template v-slot:body-cell-img="props">
        <q-td class="text-center">
          <q-img dense :src="props.value" style="width: 25px; height: 25px; cursor: pointer;" contain
                 @click="$store.commit('setSelectedProductId', props.row.id)">
            <q-tooltip anchor="center right" self="center left" :offset="[10, 10]"
                       transition-show="scale"
                       transition-hide="scale"
                       content-style="background: white; border: solid 1px black">
              <q-img dense :src="props.value.replace('.png.thumb_sm', '')" style="width: 25vw; height: 25vw;" contain/>
            </q-tooltip>
          </q-img>
        </q-td>
      </template>

      <template v-slot:body-cell-reference="props">
        <q-td :props="props">
          <router-link :to="`/admin/products/${props.row.id}`">{{props.value}}</router-link>
        </q-td>
      </template>

      <template v-slot:body-cell-name="props">
        <q-td>
          <div style="cursor: pointer;" @click="$store.commit('setSelectedProductId', props.row.id)">{{ props.row.name }}</div>
        </q-td>
      </template>

      <template v-slot:body-cell-range="props">
        <q-td>
          <div style="cursor: pointer;" @click="$store.commit('setSelectedProductId', props.row.id)">{{ props.value }}</div>
        </q-td>
      </template>

      <template v-slot:body-cell-brand="props">
        <q-td>
          <div style="cursor: pointer;" @click="$store.commit('setSelectedProductId', props.row.id)">{{ props.value }}</div>
        </q-td>
      </template>

      <template v-slot:body-cell-material="props">
        <q-td>
          <div style="cursor: pointer;" @click="$store.commit('setSelectedProductId', props.row.id)">{{ props.value }}</div>
        </q-td>
      </template>

      <template v-slot:body-cell-grip="props">
        <q-td>
          <div style="cursor: pointer;" @click="$store.commit('setSelectedProductId', props.row.id)">{{ props.value }}</div>
        </q-td>
      </template>

      <template v-slot:body-cell-holds="props">
        <q-td>
          <div style="cursor: pointer;" @click="$store.commit('setSelectedProductId', props.row.id)">{{ props.value }}</div>
        </q-td>
      </template>

      <template v-slot:body-cell-size="props">
        <q-td>
          <div style="cursor: pointer;" @click="$store.commit('setSelectedProductId', props.row.id)">{{ props.value }}</div>
        </q-td>
      </template>

      <template v-slot:body-cell-price="props">
        <td :props="props">
          <span class="float-right q-pr-md" style="cursor: pointer;" @click="$store.commit('setSelectedProductId', props.row.id)">${{ Number(props.value).toFixed(2) }}</span>
        </td>
      </template>

      <template :slot="`body-cell-${colourCol.name}`" slot-scope="props" v-for="colourCol in colourColumns">
        <q-td :style="{...getColorGridStyle(colourCol.colourName), 'width': '20px', 'text-align': 'center'}" :key="colourCol.name" v-if="storeType !== 'container'">
          <q-tooltip v-if="props.col.colourName" content-style="font-size: 1em">
            <div>{{props.col.label}}</div>
            <div>{{props.value}} in stock</div>
          </q-tooltip>
          <m-colour-popup-edit :ref="`col_edit_${colourCol.name}_${props.row.__index}`"
                               v-if="!!props.value && !groupColours" :value="props.value ? findCartQty(props.row, colourCol.colourName) : ''"
                               @save="v => updateItemInCart((findSku(props.row, colourCol.colourName) || {}).id, v)" :buttons="false"
                               @enter="popupPressedEnter(props, colourCol)" :small-controls="true"
                               min="0" inputType="number" :select-on-focus="true">
            <template v-slot:content>
              <span>
                {{props.value ? findCartQty(props.row, colourCol.colourName) : ''}} {{props.value ? '/' : ''}} {{ props.value || '' }}
              </span>
            </template>
          </m-colour-popup-edit>
          <span v-else>-</span>
        </q-td>

        <q-td :style="{...getColorGridStyle(colourCol.colourName), 'width': '20px', 'text-align': 'center'}" :key="colourCol.name" v-if="storeType === 'container'">
          <q-tooltip v-if="props.col.colourName" content-style="font-size: 1em">{{props.col.label}}</q-tooltip>
          <m-colour-popup-edit :ref="`col_edit_${colourCol.name}_${props.row.__index}`"
            v-if="!!props.value && !groupColours" :value="props.value ? findCartQty(props.row, colourCol.colourName) : ''"
            @save="v => updateItemInCart((findSku(props.row, colourCol.colourName) || {}).id, v)" :buttons="false"
            @enter="popupPressedEnter(props, colourCol)" :small-controls="true"
            min="0" inputType="number" :select-on-focus="true"
          />
          <span v-else>-</span>
        </q-td>
      </template>

      <template v-slot:header-cell="props">
        <q-th :key="props.col.name" :props="props" >
          <span v-if="!props.col.colourName && !(props.col.name === 'img')">{{props.col.label}}</span>
          <div v-else :style="{border: '1px silver solid', backgroundColor: props.col.colourHex, width: '12px',height: '12px', cursor: 'pointer', 'margin-top': '5px', 'margin-left': '1px', borderRadius: '12px'}"
               @click="setColourFilterToColourGroup(props.col.group)"
               @dblclick="setColourFilter(props.col.colourName)"
               class="inline-block">
            <q-tooltip v-if="props.col.colourName" content-style="font-size: 1em">
              <div>{{props.col.label}}</div>
              <div>Click to set filter to group "{{props.col.group}}"</div>
              <div>Double click to set filter to "{{props.col.colourName}}"</div>
            </q-tooltip>
          </div>
        </q-th>
      </template>
    </q-table>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { mapGetters, mapState } from 'vuex'
import { properCase } from '../util/string'
import MColourPopupEdit from './ui/MColourPopupEdit'
import { getReadableBackgoundColourCached } from '../util/colours'

export default {
  name: 'ProductTable',
  components: { MColourPopupEdit },
  props: {
    products: Array,
    productCount: Number,
    storeType: String
  },
  apollo: {
    displayedProducts () {
      return {
        query: gql`
          query displayedProducts ($filter: ProductFilterInput, $store: StoreType!, $limit: Int, $offset: Int, $orderBy: ProductsOrderByFieldInput, $descending: SortOrderInput) {
            products(filter: $filter, store: $store, limit: $limit, offset: $offset, orderBy: $orderBy, descending: $descending) {
              products {
                id,
                name,
                reference,
                attributes,
                images {
                  url
                  name
                },
                urlSlug,
                description,
                skus {
                  id,
                  showInContainer,
                  price,
                  retailPrice,
                  containerPrice,
                  options,
                  stock
                }
              }
              count
            }
          }
        `,
        skip: () => !this.currentAccount,
        variables () {
          return {
            filter: this.productFilterGql,
            store: properCase(this.storeType),
            limit: this.pagination.rowsPerPage,
            offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
            orderBy: this.pagination.sortBy,
            descending: this.pagination.descending ? 'Descending' : 'Ascending'
          }
        },
        update (result) {
          this.pagination.rowsNumber = result.products.count
          return result.products?.products
        },
        fetchPolicy: 'network-only'
      }
    },
    cart: {
      query: gql`
      query cart ($id: ID!) {
        cart(id: $id) {
          id
          items {
            id
            qty
            sku {
              id
              options
              product {
                id
              }
            }
          }
        }
      }
    `,
      variables () {
        return {
          id: this.cartId
        }
      },
      skip () {
        return !this.$store.state.auth.currentAccount
      }
      // fetchPolicy: 'network-only'
    }
  },
  watch: {
    filters: {
      deep: true,
      handler (newVal, oldVal) {
        this.pagination.page = 1
      }
    },
    search (newVal, oldVal) {
      this.pagination.page = 1
    }
  },
  computed: {
    ...mapState('filters', ['filters', 'search']),
    ...mapGetters('filters', ['colourGroups', 'productFilterGql']),
    cartId () {
      if (this.storeType === 'stock') {
        return this.$store.state.auth.currentAccount?.activeCartId
      } else if (this.storeType === 'container') {
        return this.$store.state.auth.currentAccount?.activeContainerCartId
      } else if (this.storeType === 'retail') {
        return this.$store.state.auth.currentAccount?.activeRetailCartId
      }
      console.error(`Unknown storeType for ProductTable: ${this.storeType}`)
      return ''
    },
    currentUUID () {
      return this.$store.state.auth.currentUUID
    },
    currentAccount () {
      return this.$store.state.auth.currentAccount
    },
    isLoggedIn () {
      if(!(!!this.$store.state.auth.currentAccount)){
                this.$router.push('/retail')
      }else{
        return true
      }
    },
    colourColumns () {
      const colourFilter = this.$store.state.filters.filters.find(filter => filter.type === 'colour')
      if (this.groupColours) {
        return this.colourGroups.map(colourGroup => {
          return {
            colourName: colourGroup.group,
            name: `colour_${colourGroup.group}`,
            required: false,
            label: colourGroup.group,
            align: 'center',
            field: row => row.skuData[colourGroup.group] || 0,
            sortable: true
          }
        }).filter(item => colourFilter ? colourFilter.values.find(colour => colour.group === item.label) : true)
      } else {
        let retVal = []
        let rowFuncFactory
        if (this.storeType === 'container') {
          rowFuncFactory = (colour) => (row) => row.skus.find(sku => sku.options.colour.name === colour.name)?.showInContainer
        } else {
          rowFuncFactory = (colour) => (row) => row.skus.find(sku => sku.options.colour.name === colour.name)?.stock || 0
        }
        const visibleColours = new Set()
        if (!this.showAllColours) {
          for (const prod of this.displayedProducts) {
            for (const sku of prod?.skus) {
              const skuColour = sku.options?.colour?.name
              if (skuColour) visibleColours.add(skuColour)
            }
          }
        }
        this.colourGroups.forEach(colourGroup => {
          colourGroup.colours.forEach(colour => {
            retVal.push({
              group: colour.group,
              superGroup: colour.superGroup,
              colourName: colour.name,
              colourHex: colour.hex,
              name: `colour_${colour.name}`,
              required: false,
              label: `${colour.group} (${colour.name})`,
              align: 'center',
              field: rowFuncFactory(colour),
              sortable: false
            })
          })
        })
        return retVal.filter(item => (colourFilter ? colourFilter.values.find(colour => colour.name === item.colourName) : true) &&
          (visibleColours.has(item.colourName) || this.showAllColours))
          .sort((a, b) => {
            const supergroupA = a?.superGroup === 'Custom' ? 'zcustom' : a?.superGroup
            const supergroupB = b?.superGroup === 'Custom' ? 'zcustom' : b?.superGroup
            const compareSuperGroup = supergroupA.localeCompare(supergroupB)
            const compareGroup = a?.group?.localeCompare(b?.group)
            // const compareRange = a.Range.localeCompare(b.Range)
            return compareSuperGroup || compareGroup // || compareRange
          })
      }
    },
    adminColumns () {
      if (!this.currentAccount?.isAdmin) return []
      return [
        { name: 'reference', required: false, label: 'Reference', align: 'left', field: row => row.reference, sortable: false }
      ]
    },
    columns () {
      const priceFieldName = {
        'container': 'containerPrice',
        'retail': 'retailPrice',
        'stock': 'price'
      }[this.storeType]
      return [
        { name: 'img', label: 'Image', field: row => row.images?.[0]?.url + '.png.thumb_sm' },
        ...this.adminColumns,
        { name: 'brand', required: false, label: 'Brand', align: 'left', field: row => row.attributes.brand, sortable: true },
        { name: 'range', required: false, label: 'Range', align: 'left', field: row => row.attributes.range, sortable: true },
        { name: 'name', required: false, label: 'Name', align: 'left', field: row => row.name, sortable: true },
        { name: 'material', required: false, label: 'Material', align: 'left', field: row => row.attributes.material, sortable: true },
        { name: 'size', required: false, label: 'Size', align: 'left', field: row => row.attributes.size, sortable: true },
        { name: 'grip', required: false, label: 'Grip', align: 'left', field: row => row.attributes.grip, sortable: true },
        { name: 'holds', required: false, label: 'Holds', align: 'left', field: row => row.attributes.holds, sortable: true },
        { name: 'price', required: false, label: 'Price', align: 'right', field: row => Number(row.skus?.[0]?.[priceFieldName] || 0), sortable: true },
        ...this.colourColumns
      ]
    }
  },
  methods: {
    async updateItemInCart (skuId, value) {
      value = Number(value)
      try {
        if (value > 0 && !this.cart.items.find(item => item.sku.id === skuId)) {
          await this.$apollo.mutate({
            mutation: gql`mutation addItemToCart($cartId: ID!, $input: CartItemInput!) {
                addItemToCart (id: $cartId, input: $input) {
                    id
                    items {
                        id
                        skuId
                        sku {
                            id
                            price
                            options
                            stock
                            product {
                                id,
                                name,
                                attributes,
                            }
                        }
                        qty
                    }
                }
            }
            `,
            variables: {
              cartId: this.cartId,
              input: {
                skuId: skuId,
                qty: value
              }
            },
            context: {
              headers: {
                uuid: this.currentUUID
              }
            }
          })
          const skuToSendToAnalytics = this.cart.items.find(item => item.sku.id === skuId).sku
          // eslint-disable-next-line no-undef
          analytics.track('Add Item To Cart', {
            cartId: this.cartId,
            skuId,
            sku: skuToSendToAnalytics,
            qty: value,
            where: 'product table'
          })
        } else if (value === 0) {
          await this.$apollo.mutate({
            mutation: gql`mutation deleteItemFromCart($cartId: ID!, $skuId: ID!) {
              deleteItemFromCart (id: $cartId, skuId: $skuId) {
                  id
                  items {
                      id
                      skuId
                      qty
                  }
              }
          }
          `,
            variables: {
              cartId: this.cartId,
              skuId: skuId
            }
          })
          // eslint-disable-next-line no-undef
          analytics.track('Delete Item From Cart', {
            cartId: this.cartId,
            skuId,
            where: 'product table'
          })
        } else {
          await this.$apollo.mutate({
            mutation: gql`mutation editItemInCart($cartId: ID!, $skuId: ID!, $input: CartItemInput!) {
                editItemInCart (id: $cartId, skuId: $skuId, input: $input) {
                    id
                    items {
                        id
                        skuId
                        qty
                    }
                }
            }
            `,
            variables: {
              cartId: this.cartId,
              skuId: skuId,
              input: {
                qty: value
              }
            },
            context: {
              headers: {
                uuid: this.currentUUID
              }
            }
          })
          // eslint-disable-next-line no-undef
          analytics.track('Edit Item In Cart', {
            cartId: this.cartId,
            skuId,
            updates: {
              qty: value
            },
            where: 'product table'
          })
        }
      } catch (err) {
        this.$q.notify({
          message: 'Error updating!',
          color: 'negative',
          icon: 'report_problem'
        })
      }
      this.$store.commit(`cart/setCart${properCase(this.storeType)}Qty`,this.cart.items?.reduce((p, c, i) => p + Number(c.qty), 0))
    },
    findCartQty  (row, colourName) {
      return (this.cart?.items || []).find(item => item.sku?.options?.colour?.name === colourName && item.sku?.product?.id === row.id)?.qty || 0
    },
    findSku  (row, colourName) {
      return (row.skus || []).find(sku => sku.options.colour.name === colourName)
    },
    getColourGridStyleFromColour (colour) {
      return {
        'background-color': colour.hex,
        color: getReadableBackgoundColourCached(colour.hex)
      }
    },
    getColorGridStyle (col) {
      if (this.groupColours) return this.getColorGridStyleGrouped(col)
      return this.getColorGridStyleNormal(col)
    },
    getColorGridStyleNormal (col) {
      const colour = this.$store.state.filters.colours.find(c => c.name === col)
      return this.getColourGridStyleFromColour(colour)
    },
    getColorGridStyleGrouped (col) {
      const colour = this.colourGroups.find(c => c.group === col)
      return this.getColourGridStyleFromColour(colour)
    },
    popupPressedEnter (props, colourCol) {
      try {
        this.$refs[`col_edit_${colourCol.name}_${props.row.__index + 1}`][0].show()
      } catch (e) {
        // Must be at the end...
      }
    },
    onRequest (props) {
      let { page, rowsPerPage, sortBy, descending } = props.pagination
      this.pagination.page = page
      this.pagination.rowsPerPage = rowsPerPage
      this.pagination.sortBy = sortBy
      this.pagination.descending = descending
    },
    setColourFilter (colourName) {
      const colour = this.$store.state.filters.colours.find(colour => colour.name === colourName)
      if (!colour) return
      this.$store.commit('filters/addOrUpdateFilterByType', {
        filter: {
          type: 'colour',
          values: [colour]
        }
      })
    },
    setColourFilterToColourGroup (colourGroup) {
      const colours = this.$store.state.filters.colours.filter(colour => colour.group === colourGroup)
      if (!colours.length) return
      this.$store.commit('filters/addOrUpdateFilterByType', {
        filter: {
          type: 'colour',
          values: colours
        }
      })
    }
  },
  data () {
    return {
      showAllColours: false,
      groupColours: false,
      visibleColumns: [], // updated again in 'created'
      currentPage: 1,
      displayedProducts: [],
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 100,
        rowsNumber: 10,
        sortBy: 'range'
      },
      loading: false
    }
  },
  created () {
    this.visibleColumns = this.columns.map(c => c.name)
    this.$store.state.filters.colours.forEach(colour =>
      this.visibleColumns.push(`colour_${colour.name}`)
    )
    this.onRequest({ pagination: this.pagination })
  }
}
</script>

<style lang="stylus">
</style>
